import React, { useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../common/components';
const ListMyAllTasksPage = loadable(() => import('./ListMyAllTasksPage'), {
    fallback: <Loader/>,
});
const MyAllTasksRoute = ({ t, alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListMyAllTasksPage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
MyAllTasksRoute.propTypes = {
  t: PropTypes.func
};
export default MyAllTasksRoute;
